// components/playground/sections/UnsavedChangesDialog.jsx
import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const UnsavedChangesDialog = ({
  isOpen,
  scenarioName,
  onUpdate,
  onDiscard,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full">
        {/* Icon & Title */}
        <div className="px-6 py-4 flex items-start gap-4">
          <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0">
            <ExclamationTriangleIcon className="w-6 h-6 text-orange-600" />
          </div>
          <div className="flex-1">
            <h2 className="text-xl font-bold text-gray-900 mb-2">
              Unsaved Changes
            </h2>
            <p className="text-sm text-gray-600">
              You have unsaved changes to <span className="font-semibold">"{scenarioName}"</span> scenario.
            </p>
            <p className="text-sm text-gray-600 mt-2">
              What would you like to do?
            </p>
          </div>
        </div>

        {/* Actions */}
        <div className="px-6 py-4 space-y-2">
          <button
            onClick={onUpdate}
            className="w-full px-4 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors text-sm font-medium flex items-center justify-center gap-2"
          >
            <span>💾</span>
            <span>Update Scenario</span>
          </button>
          <button
            onClick={onDiscard}
            className="w-full px-4 py-3 bg-white text-orange-600 border border-orange-300 rounded-lg hover:bg-orange-50 transition-colors text-sm font-medium"
          >
            Discard Changes
          </button>
          <button
            onClick={onCancel}
            className="w-full px-4 py-3 bg-white text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnsavedChangesDialog;